
import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Star } from 'lucide-react';
import { Reward as RewardType } from '@/utils/storage';

interface ClaimRewardDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  reward: RewardType | null;
}

const ClaimRewardDialog: React.FC<ClaimRewardDialogProps> = ({
  open,
  onOpenChange,
  onConfirm,
  reward
}) => {
  if (!reward) return null;

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Claim Reward</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to claim "{reward.title}" for{' '}
            <span className="inline-flex items-center gap-1">
              <Star size={16} className="text-yellow-400 fill-yellow-400" />
              {reward.cost}
            </span>{' '}
            stars?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>
            Claim Reward
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default ClaimRewardDialog;
